export const PATHS = {
  CHECK_EMAIL: 'registration/status',
  SEND_APPLICATION: '/applications',
  RESEND_LINK: '/registration/sendSelfRegistrationCode',
  STATION_TYPES: 'refs/stationTypes',
}
